import AddProductToShoppingListModal from './AddProductToShoppingListModal';

export default AddProductToShoppingListModal;
